module.exports = __webpack_public_path__ + "fonts/fe565f9.ttf";